<button
  type="button"
  class="info-row"
  [class.disabled]="disabled"
  [disabled]="disabled"
  (click)="onClick()"
>
  <span class="row-label">{{ label }}</span>
  <span class="row-value-group">
    <span class="row-value">{{ value }}</span>
    <ion-icon class="row-chevron" name="chevron-forward-outline" aria-hidden="true" />
  </span>
</button>
